import React from "react"
import { ClientesFornecedorContextProvider } from "./context/ClientesFornecedorContextProvider"
import { ClientesFornecedor } from "./ClientesFornecedor"

export function Index() {
    return (
        <ClientesFornecedorContextProvider>
            <ClientesFornecedor />
        </ClientesFornecedorContextProvider>
    )
}
